import type { IRequiredToastAction } from '../actions';
import { TOAST_REQUIRED } from '../actions';

export default (state: any, action: IRequiredToastAction) => {
  if (!state) {
    return {
      required: false,
    };
  }

  switch (action.type) {
    case TOAST_REQUIRED:
      return {
        required: action.required,
      };
    default:
      break;
  }

  return state;
};
